module.exports = __webpack_public_path__ + "static/media/h5备份 1.83a17a6c.jpg";